/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.IPage<defs.basics.ListingQuoteModel>>;
export function request(
  params: API.basics.listingQuote.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/listingQuote/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
